export default {
    TimeFormat:     "YYYY/MM/DD hh:mm:ss"
    /*
    // テスト用。いろんなフォーマットでも問題無いか検証するために残します(テスト終わって問題無いならコメントを削除)
    TimeFormat2:    "YY/MM/DD hh:mm",
    TimeFormat3:    "MM/YY/DD hh;mm;ss",
    */
}